import React from 'react'

import {
    paletaTonsVermelho,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import EstudoFormDespesasDespesaMensalDetalhada from '../estudo-form/EstudoFormDespesasDespesaMensalDetalhada'

import GraficoBarrasChart from './GraficoBarrasChart'



const DespesaAnualChart = ( { values, setFieldValue, estudo, vars, report, popup, moreLessList } ) => {

    return (
        <GraficoBarrasChart
            values={values}
            setFieldValue={setFieldValue}
            estudo={estudo}
            vars={vars}
            report={report}
            popup={popup}
            grafico={estudo.current.graficoDespesaAnual}
            media={estudo.current.graficoDespesaAnualMedia}
            paletaTons={paletaTonsVermelho}
            title={LABEL.despesaAnualLongoTempo}
            participacao={true}
            tabela={
                <EstudoFormDespesasDespesaMensalDetalhada
                    values={values}
                    estudo={estudo}
                    vars={vars}
                    popup={true}
                    popupGrafico={false}
            />
            }
            tabelaTitle={LABEL.despesaMensal}
            zoom={true}
            titleZoomTabela={LABEL.tipoDespesa}
            moreLessList={moreLessList}
            idListaMoreLess={HARDCODE.despesaAnualChart}
        />
    )
}

export default DespesaAnualChart